var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"section-container"},[_c('p',{staticClass:"section-title",class:_vm.computedFontTitle},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.subtitle)?_c('div',{staticClass:"text-h-4 section-subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }